import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import classNames from 'classnames';

import {
  academyProjectSelector,
  setAcademyProject,
} from 'features/classCreation';
import AcademyProjectChip from '../AcademyProjectChip';
import Field from 'components/Field';
import Input from 'components/Input';
import styles from './AcademyProjectField.module.scss';

export default function AcademyProjectField({ errors }) {
  const dispatch = useDispatch();
  const academyProject = useSelector(academyProjectSelector);
  const { test_id: academyProjectTestId, title: academyProjectTitle } =
    academyProject || {};

  const handleRemoveClick = useCallback(() => {
    batch(() => {
      dispatch(setAcademyProject(null));
    });
  }, [dispatch]);

  return (
    <Field
      label="Case Study"
      className="m-b-l"
      serverErrors={errors}
    >
      {academyProjectTestId && (
        <>
          <Input
            value={academyProjectTestId}
            className={styles.input}
            disabled
          />
          <Input
            value={academyProjectTitle}
            className={styles.input}
            disabled
          />
          <Tappable
            className={classNames('btn btn-danger', styles.removeButton)}
            onClick={handleRemoveClick}
          >
            <Icon
              name="close"
              className="m-r-xxs"
            />
            Remove
          </Tappable>
        </>
      )}
      {!academyProjectTestId && <AcademyProjectChip />}
      <div className="h6 disabled m-t-xs">
        You can link case study to a class while scheduling
      </div>
    </Field>
  );
}
